import gql from 'graphql-tag';

export const FishingWaterReviewFragments = {
  id: gql`
    fragment FishingWaterReviewId on FishingWaterReview {
      _id: externalId
    }
  `,
};
